<script>
  import { portal_url } from "./stores.js";
  import { query } from "./stores.js";
  import { filter_query } from "./helpers";
  import { get_parameters } from "./helpers";
  import SearchCard from "./SearchCard.svelte";
  import { onDestroy } from "svelte";
  import { afterUpdate } from "svelte";

  let results = {};
  let items = [];
  let next_url = "";
  let y;
  let load_more_button = null;

  const checkVisible = function (elm) {
    // Is the element fully in view?
    if (!elm) {
      return false;
    }
    let rect = elm.getBoundingClientRect();
    let viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight
    );
    return !(rect.bottom < 0 || rect.bottom - viewHeight >= 0);
  };

  // afterUpdate is called after the DOM is updated.
  afterUpdate(() => {
    if (checkVisible(load_more_button)) {
      load_more();
    }
  });

  const search = async (search_url) => {
    // Note: when search_url is on a different host or port,
    // the query is anonymous.

    // Always make next_url empty.
    // This avoids running two searches at the same time.
    next_url = "";
    if (!search_url) {
      // Start a new search.
      results = {};
      items = [];
      search_url = $portal_url + "/@search";
      let sorted_query = {};
      Object.assign(sorted_query, filter_query($query));
      if (Object.keys(sorted_query).length === 0) {
        return;
      }
      Object.assign(sorted_query, {
        b_size: 24,
        sort_on: "effective",
        sort_order: "reverse",
        metadata_fields: ["theme_title", "mina_date", "getIcon", "getObjSize"],
      });

      let parameters = get_parameters(sorted_query);
      search_url += "?" + parameters.join("&");
    }
    const res = await fetch(search_url, {
      headers: new Headers({ Accept: "application/json" }),
    });
    results = await res.json();
    if (results.items === undefined) {
      results.items = [];
    }
    if (!results.batching) {
      items = results.items;
      next_url = "";
    } else {
      // Add new items to current items.
      items = [...items, ...results.items];
      next_url = results.batching.next;
    }
  };

  const load_more = async () => {
    search(next_url);
  };
  // Subscribe to changes of query,
  // and make sure we unsubscribe when we are destroyed.
  const unsubscribe_query = query.subscribe((value) => {
    search();
  });
  onDestroy(unsubscribe_query);
</script>

<!-- The next construction means that every time we scroll vertically,
     the 'y' variable is updated.  This result in a DOM update.
     And that means 'afterUpdate' is called.
     There we check if we should load more results. -->
<svelte:window bind:scrollY={y} />

<fieldset>
  <div class="row">
    {#each items as item}
      <SearchCard {item} />
    {:else}
      <div class="item">Geen zoekresultaten</div>
    {/each}
  </div>
  {#if next_url}
    <div class="item">
      <button bind:this={load_more_button} on:click={load_more}
        >Laad meer zoekresultaten</button
      >
    </div>
  {/if}
</fieldset>

<style>
  button {
    padding: 2em;
    font-weight: bold;
    background-color: greenyellow;
  }
</style>
